import React from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Paper } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { deletePayrolls } from "@redux/actions";
import {
  modalHeader,
  modalStyle,
  modalBody,
  modalFooter,
} from "@styles/styledComponents";

const DeletePayrollsModal = (props) => {
  const dispatch = useDispatch();
  const deletePayrollsAction = async () => {
    const { payrollIdsToDelete } = props;
    if (payrollIdsToDelete && payrollIdsToDelete.length > 0) {
      dispatch(deletePayrolls({ payrollIds: payrollIdsToDelete })).then(() => {
        props.closeModal();
        window.location.reload();
      });
    }
  };

  return (
    <>
      <div>
        <Modal
          open={true}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          style={modalStyle}
        >
          <Fade in={true}>
            <Paper elevation={3} variant="normal" square>
              <div style={modalHeader}>
                <p>Delete Confirmation</p>
              </div>
              <div style={modalBody}>
                Are you sure you want to delete these Payrolls?
              </div>
              <div style={modalFooter}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={props.closeModal}
                >
                  Close
                </Button>
                &nbsp;&nbsp;&nbsp;
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={deletePayrollsAction}
                >
                  Delete
                </Button>
              </div>
            </Paper>
          </Fade>
        </Modal>
      </div>
    </>
  );
};
export default connect(null, {
  deletePayrolls,
})(DeletePayrollsModal);
